import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangePipePipe } from '../helpers/date-range-pipe.pipe';
import { ClampDirective } from '../helpers/clamp.directive';
import { ModalWrapperComponent } from '../components/modal-wrapper/modal-wrapper.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    DateRangePipePipe,
    ClampDirective,
    ModalWrapperComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
  ],
  exports: [
    DateRangePipePipe,
    ClampDirective,
    ModalWrapperComponent
  ]
})
export class SharedModule { }
